import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { AuthWordmark } from "./AuthWordmark";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      setError("Please enter a valid email.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      // The backend always responds 200 regardless of whether the account
      // exists (no account enumeration), so any success → show the sent state.
      await api.post("/api/auth/forgot", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card-wrap">
        <AuthWordmark />

        <div className="card">
          <div className="card-body auth-stack">
            {sent ? (
              <div className="signup-success">
                <div className="signup-success-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="auth-title">Check your email</div>
                <p className="auth-sub">
                  If an account exists for <strong>{email}</strong>, we've sent a link to reset
                  your password.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="auth-stack">
                <div>
                  <div className="auth-title">Reset your password</div>
                  <p className="auth-sub" style={{ marginTop: 6 }}>
                    Enter your email and we'll send you a link to set a new password.
                  </p>
                </div>

                {error && <div className="form-error" role="alert">{error}</div>}

                <label className="field">
                  <span className="field-label">Email</span>
                  <input
                    type="email"
                    className="field-input"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </label>

                <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                  {loading ? "Sending…" : "Send reset link"}
                </button>
              </form>
            )}
          </div>
        </div>

        <p className="auth-foot">
          Remembered it? <Link to="/login">Sign in</Link>
        </p>
        <p className="auth-back">
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </div>
  );
}
